import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API } from 'aws-amplify';

/**
 * Handles proxy link redirects (/p/:code)
 * Calls backend to record click and get product info, then redirects to product page
 */
function ProxyRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function handleRedirect() {
      try {
        // Call backend to record click and get redirect info
        const response = await API.get('printifyapi', `/api/p/${code}/info`, {});

        if (response.success && response.productId) {
          // Set referrer in localStorage for commission tracking
          if (response.referrerId) {
            localStorage.setItem('referrerId', response.referrerId);
            localStorage.setItem('referrerExpiry', Date.now() + (7 * 24 * 60 * 60 * 1000)); // 7 days
          }

          // Navigate to product page
          navigate(`/products/${response.productId}?ref=${response.referrerId}`, { replace: true });
        } else {
          // Link not found, redirect to home
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('Error handling proxy redirect:', err);
        navigate('/', { replace: true });
      }
    }

    if (code) {
      handleRedirect();
    }
  }, [code, navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-slate-600">Redirecting...</p>
      </div>
    </div>
  );
}

export default ProxyRedirect;
